import React from 'react';
import { SVG } from 'web-common/src/shared/design-system/Utilities';

export const ShareIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <SVG width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M4 10V20H20V10' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path fillRule='evenodd' clipRule='evenodd' d='M14 6L17 6L14 3L12 1L10 3L7 6L10 6V15H14V6Z' fill='currentColor' />
  </SVG>
);
